export const TypesIniciarDesova = {
    SET_NODES: 'SET_NODES',
    SET_NODES_EXPANDED: 'SET_NODES_EXPANDED',
    RESET_INICIAR_DESOVA: 'RESET_INICIAR_DESOVA'
}

const INITIAL = {
    nodes: [],
    nodesExpanded: []
}

export default function iniciarDesovaReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesIniciarDesova.SET_NODES:
            return {
                ...state,
                nodes: action.payload
            };
        case TypesIniciarDesova.SET_NODES_EXPANDED:
            return {
                ...state,
                nodesExpanded: action.payload
            }
        case TypesIniciarDesova.RESET_INICIAR_DESOVA:
            return INITIAL;
        default:
            return state;
    }
}

export const IniciarDesovaActions = {
    setNodes,
    setNodesExpanded,
    resetIniciarDesova
}

function setNodes(nodes) {
    return {
        type: TypesIniciarDesova.SET_NODES,
        payload: nodes
    }
}

function setNodesExpanded(nodesExpanded) {
    return {
        type: TypesIniciarDesova.SET_NODES_EXPANDED,
        payload: nodesExpanded
    }
}

function resetIniciarDesova() {
    return {
        type: TypesIniciarDesova.RESET_INICIAR_DESOVA
    }
}